import axios from 'axios';

export type StatusAcao =
  | 'planejada'
  | 'em_tramitacao'
  | 'em_andamento'
  | 'concluida'
  | 'cancelada';

export interface Acao {
  id: string;
  tenant_id: string;
  titulo: string;
  tipo: string;
  bairro?: string;
  tema?: string;
  status: StatusAcao;
  progresso: number;
  valor?: number | string;
  emenda_id?: string;
  solicitacoes_resolvidas: number;
  alcance?: number;
  comunicado?: string;
  marco?: string;
  concluida_em?: string;
  created_at: string;
  updated_at: string;
}

export interface FiltroAcao {
  search?: string;
  bairro?: string;
  tema?: string;
  tipo?: string;
  status?: StatusAcao;
}

const API_URL = import.meta.env.VITE_API_URL || '/api';
const auth = (token: string) => ({ headers: { Authorization: `Bearer ${token}` } });

export const acoesApi = {
  list: async (filtros: FiltroAcao, token: string) => {
    const res = await axios.get<Acao[]>(`${API_URL}/gab/acoes`, { ...auth(token), params: filtros });
    return res.data;
  },

  get: async (id: string, token: string) => {
    const res = await axios.get<Acao>(`${API_URL}/gab/acoes/${id}`, auth(token));
    return res.data;
  },

  create: async (data: Partial<Acao>, token: string) => {
    const res = await axios.post<Acao>(`${API_URL}/gab/acoes`, data, auth(token));
    return res.data;
  },

  update: async (id: string, data: Partial<Acao>, token: string) => {
    const res = await axios.put<Acao>(`${API_URL}/gab/acoes/${id}`, data, auth(token));
    return res.data;
  },

  concluir: async (id: string, comunicado: string | undefined, token: string) => {
    const res = await axios.post<Acao>(
      `${API_URL}/gab/acoes/${id}/concluir`,
      { comunicado },
      auth(token),
    );
    return res.data;
  },

  delete: async (id: string, token: string) => {
    await axios.delete(`${API_URL}/gab/acoes/${id}`, auth(token));
  },
};
